// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Table.module.scss  */
.Table-module-Wrapper_3dr {
  overflow: auto;
  flex-grow: 1;
  width: 100%;
  max-height: 100%; }

.Table-module-Root_1Jw {
  box-sizing: border-box;
  width: 100%;
  border-spacing: 0 4px;
  border-collapse: separate;
  border: none; }
  .Table-module-Root_1Jw.Table-module-resizable_2Ef {
    table-layout: fixed; }
  .Table-module-Root_1Jw.Table-module-stickyHeader_iFs thead {
    position: sticky;
    z-index: 4;
    top: 0; }
    .Table-module-Root_1Jw.Table-module-stickyHeader_iFs thead th {
      background-color: #eee; }

/* Variants */
.Table-module-defaultVariant_AMf tbody td {
  background-color: #fff; }

.Table-module-highlightedEvenVariant_2Cb tbody tr:nth-child(even) td {
  background-color: #fff; }

.Table-module-highlightedEvenVariant_2Cb tbody tr:nth-child(odd) td {
  background-color: #eee; }

.Table-module-highlightedOddVariant_2nS tbody tr:nth-child(odd) td {
  background-color: #fff; }

.Table-module-highlightedOddVariant_2nS tbody tr:nth-child(even) td {
  background-color: #eee; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Table/Table.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,gBAAgB,EAAE;;AAEpB;EACE,sBAAsB;EACtB,WAAW;EACX,qBAAqB;EACrB,yBAAyB;EACzB,YAAY,EAAE;EACd;IACE,mBAAmB,EAAE;EACvB;IACE,gBAAgB;IAChB,UAAU;IACV,MAAM,EAAE;IACR;MACE,sBAAsB,EAAE;;AAE9B,aAAa;AACb;EACE,sBAAsB,EAAE;;AAE1B;EACE,sBAAsB,EAAE;;AAE1B;EACE,sBAAsB,EAAE;;AAE1B;EACE,sBAAsB,EAAE;;AAE1B;EACE,sBAAsB,EAAE","sourcesContent":["/*  imported from Table.module.scss  */\n.Table-module-Wrapper_3dr {\n  overflow: auto;\n  flex-grow: 1;\n  width: 100%;\n  max-height: 100%; }\n\n.Table-module-Root_1Jw {\n  box-sizing: border-box;\n  width: 100%;\n  border-spacing: 0 4px;\n  border-collapse: separate;\n  border: none; }\n  .Table-module-Root_1Jw.Table-module-resizable_2Ef {\n    table-layout: fixed; }\n  .Table-module-Root_1Jw.Table-module-stickyHeader_iFs thead {\n    position: sticky;\n    z-index: 4;\n    top: 0; }\n    .Table-module-Root_1Jw.Table-module-stickyHeader_iFs thead th {\n      background-color: #eee; }\n\n/* Variants */\n.Table-module-defaultVariant_AMf tbody td {\n  background-color: #fff; }\n\n.Table-module-highlightedEvenVariant_2Cb tbody tr:nth-child(even) td {\n  background-color: #fff; }\n\n.Table-module-highlightedEvenVariant_2Cb tbody tr:nth-child(odd) td {\n  background-color: #eee; }\n\n.Table-module-highlightedOddVariant_2nS tbody tr:nth-child(odd) td {\n  background-color: #fff; }\n\n.Table-module-highlightedOddVariant_2nS tbody tr:nth-child(even) td {\n  background-color: #eee; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
